import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PraksisstedprofilDto as UhaPraksisstedprofilDto } from '../../../api/generated/studiested-generated-api';
import { PraksisstedprofilDto as PsaPraksisstedprofilDto } from '../../../api/generated/praksissted-generated-api';
import translations from '../practiceplaceprofile.i18n';
import { formatLocaleNo } from '../../../date.utils';

type PraksisstedprofilDto = UhaPraksisstedprofilDto | PsaPraksisstedprofilDto;

export const hasLastEditedByInfo = (data: PraksisstedprofilDto) => {
  return !!(
    data.sistEndretAvPraksisstedbruker || data.sistEndretAvStudiestedbruker
  );
};

interface LastEditedByProps {
  praksisstedprofil: PraksisstedprofilDto;
  className: string;
}

export const LastEditedBy: React.FC<
  React.PropsWithChildren<LastEditedByProps>
> = ({
  praksisstedprofil: {
    sistEndretAvPraksisstedbruker,
    sistEndretAvStudiestedbruker,
    sistEndret,
  },
  className,
}) => {
  const editedBy: string = useMemo(() => {
    const person =
      sistEndretAvPraksisstedbruker || sistEndretAvStudiestedbruker;

    if (!person) return '';

    return `${person.fornavn} ${person.etternavn}`;
  }, [sistEndretAvPraksisstedbruker, sistEndretAvStudiestedbruker]);

  const { formatMessage } = useIntl();
  const labels = useMemo(
    () => ({
      lastEditedBy: formatMessage(
        { id: translations.lastEditedBy.id },
        { name: editedBy },
      ),
    }),
    [formatMessage, editedBy],
  );

  const lastEditedByString = editedBy ? labels.lastEditedBy : '';
  const lastEditedDateString = sistEndret
    ? `- ${formatLocaleNo(sistEndret)}`
    : '';

  return (
    <p className={className}>
      {`${lastEditedByString} ${lastEditedDateString}`}
    </p>
  );
};
